import { render, staticRenderFns } from "./rule-form-tab2-action.vue?vue&type=template&id=3bde4b1a&scoped=true&"
import script from "./rule-form-tab2-action.vue?vue&type=script&lang=ts&"
export * from "./rule-form-tab2-action.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bde4b1a",
  null
  
)

export default component.exports